import React, { Component } from "react";
import { DialogContainer, TextField, Checkbox, CardActions, Button } from "react-md";
import { DatePicker } from 'react-md/lib/Pickers';
import { withSnackbar } from "notistack";
import { objToArray } from './services/array';
import firebase from "firebase/app";

class TankCreateOrEdit extends Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            create: true,
            disabled: false,
            invalidSensor: true,
            sensor: {id: ''}
        };
    }

    show = (item, disabled, isAdmin, clienteSensors) => {

        let sensor = {
            id: null,
            name: null,
            capacity: null,
            height: null,
            length: null,
            width: null,
            hspace: null,
            fineadjustment: null,
            installationDate: new Date().toLocaleDateString("en-US"),
            status: false
        };

        if(item){
            if (item.props && item.props.tank) {
                sensor = item.props.tank;
            }
        }

        this.setState({ visible: true, sensor, disabled, create: !item, isAdmin, clienteSensors });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    save = () => {
        if (this.state.create)
            this.create();
        else
            this.update();
    }

    create = () => {
        let { sensor, isAdmin } = this.state;

        if (isAdmin) {
            let FIREBASE_REF_SENSORSLIST = firebase.database().ref('/storage/sensors_list');
            let newSensorList = FIREBASE_REF_SENSORSLIST.child(sensor.id)
            newSensorList.set({
                id: sensor.id,
                createdAt: Date.now(),
                props: {
                    tank: { ...sensor }
                }
            }, (error) => {
                if (error)
                    this.props.enqueueSnackbar(error, { variant: "error" });
                else {
                    this.props.enqueueSnackbar("Data Saved!", { variant: "success" });
                    this.hide();
                    this.props.modalSave();
                }
            });
            /* DUPLICATING DATA IN THE BACKEND FOR PERFORMANCE */
            let FIREBASE_REF_SENSORS = firebase.database().ref('/sensors');
            let newSensor = FIREBASE_REF_SENSORS.child(sensor.id)
            newSensor.set({
                id: sensor.id,
                createdAt: Date.now(),
                props: {
                    tank: { ...sensor }
                }
            }, (error) => {});
            /* ADDING TO ADMIN LIST OF SENSORS*/
            this.addSensorinUsersList();
        }
        else {
            this.addSensorinUsersList();
        }
    }

    addSensorinUsersList = () => {
        let { sensor, clienteSensors } = this.state;

        let clienteSensorsArray = objToArray(clienteSensors);
        let index = clienteSensorsArray.findIndex(x => x.sensorId === sensor.id);
        if (index >= 0) {
            this.props.enqueueSnackbar('sensor already registered', { variant: "error" });
            return;
        }

        let sensorAssociatedwithUser = {
            sensorId: sensor.id,
            createdAt: Date.now(),
            sensorName: sensor.name ? sensor.name : sensor.props.tank.name, // FIX THIS
            capacity: sensor.capacity ? sensor.capacity : sensor.props.tank.capacity // FIX THIS
        }

        let currentUser = firebase.auth().currentUser;
        firebase.database().ref(`/storage/users/${currentUser.uid}/sensors/${sensor.id}`)
            .set(sensorAssociatedwithUser, (error) => {
                if (error)
                    this.props.enqueueSnackbar(error, { variant: "error" });
                else {
                    this.props.enqueueSnackbar("Data Saved!", { variant: "success" });
                    this.hide();
                    this.props.modalSave();
                }
            })

        let userAssociatedWithSensor = {
            uid: currentUser.uid,
            userName: currentUser.displayName,
            email: currentUser.email,
            createdAt: Date.now()
        }
        firebase.database().ref(`/storage/sensors_list/${sensor.id}/users/${currentUser.uid}`)
            .set(userAssociatedWithSensor, (error) => {
                if (error)
                    this.props.enqueueSnackbar(error, { variant: "error" });
                else {
                    this.props.enqueueSnackbar("Data Saved!", { variant: "success" });
                    this.hide();
                    this.props.modalSave();
                }
            })
    }

    update = () => {
        let { sensor } = this.state;

        let FIREBASE_REF_SENSORSLIST = firebase.database().ref('/storage/sensors_list');
        let FIREBASE_REF_TANKLIST = FIREBASE_REF_SENSORSLIST.child(sensor.id).child('props').child('tank');
        FIREBASE_REF_TANKLIST.update({ ...sensor })
            .then(() => {
                this.props.enqueueSnackbar("Data Saved!", { variant: "success" });
                this.hide();
                this.props.modalSave();
            })
            .catch(error => {
                this.props.enqueueSnackbar(error, { variant: "error" });
            })
        /* DUPLICATING DATA IN THE BACKEND FOR PERFORMANCE */
        let FIREBASE_REF_SENSORS = firebase.database().ref('/sensors');
        let FIREBASE_REF_TANK = FIREBASE_REF_SENSORS.child(sensor.id).child('props').child('tank');
        FIREBASE_REF_TANK.update({ ...sensor })
            .then(() => {
                this.hide();
                this.props.modalSave();
            })
            .catch(error => {
                this.props.enqueueSnackbar(error, { variant: "error" });
            })
        /* UPDATE NAME AND CAPACITY AT CLIENT RELATIONSHIP */
        let uid = firebase.auth().currentUser.uid;
        firebase.database().ref(`/storage/users/${uid}/sensors/${sensor.id}/`)
            .update({ sensorName: sensor.name, capacity: sensor.capacity })
            .then(() => {
                this.hide();
                this.props.modalSave();
            })
            .catch(error => {
                this.props.enqueueSnackbar(error, { variant: "error" });
            })
    }

    updateObject = (field, value) => {
        let sensor = this.state.sensor;
        sensor[field] = value;
        this.setState({ sensor });
    }

    loadSensor = (sensorId) => {
        if (sensorId && sensorId.length){
        if (!this.state.isAdmin && sensorId.length > 6) {
            let FIREBASE_REF_SENSORS = firebase.database().ref('/storage/sensors_list');
            FIREBASE_REF_SENSORS.child(sensorId)
                .once("value").then((snapshot) => {
                    let sensor = snapshot.val();
                    if (sensor) {
                        let tank = sensorId;
                        if (sensor.props && sensor.props.tank)
                            tank = sensor.props.tank;
                        this.setState({
                            invalidSensor: false,
                            tank,
                            sensor: {
                                id: sensorId,
                                ...sensor
                            }
                        });
                        this.props.enqueueSnackbar(`Sensor ${sensorId} was found, click save!`, { variant: "info" });
                    }
                    else {
                        // this.props.enqueueSnackbar(`Sensor ${this.state.sensor.id} not found`, { variant: "error" });
                        this.setState({ invalidSensor: true });
                    }
                });
            }
        }
    }

    render() {
        let { visible, sensor, disabled, create, isAdmin, invalidSensor } = this.state;

        if (!visible)
            return null;

        let title = !isAdmin ? "Add Sensor" : "Create Sensor";
        if (!create)
            if (disabled)
                title = `View Sensor (${sensor.id})`;
            else
                title = `Edit Sensor (${sensor.id})`;

        let sensorIdClassName = "md-cell md-cell--12 md-cell--6-desktop";
        if (!isAdmin && !disabled)
            sensorIdClassName = "md-cell md-cell--12 md-cell--12-desktop";

        return (
            <div className="md-text">
                <DialogContainer
                    id="tank-create-or-edit-dialog"
                    visible={visible}
                    title={title}

                    dialogClassName="md-cell md-cell--12 md-cell--12-desktop"
                    titleClassName="md-text md-divider-border md-divider-border--bottom"

                    closeOnEsc={false}
                    onHide={() => { }}

                    focusOnMount={false}
                    containFocus={false}
                >
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        this.save()
                    }}>
                        <div className="md-grid">
                            <TextField
                                required
                                type="text"
                                label="Sensor Id"
                                id="sensorId"
                                //maxLength={8} // change to 8
                                className={sensorIdClassName}
                                onChange={val => this.setState({ sensor: { id: val.replace(/[^\w\s/-]/gi, "") } })} //TODO in the other form fields to prevent special characters on firebase paths
                                value={sensor.id}
                                disabled={disabled || !create}
                                onKeyUp={() => this.loadSensor(sensor.id)}
                            />
                            {
                                isAdmin || (!isAdmin && disabled) ?
                                    <TextField
                                        required
                                        type="text"
                                        label="Name"
                                        id="name"
                                        className="md-cell md-cell--12 md-cell--6-desktop"
                                        onChange={val => this.updateObject('name', val)}
                                        value={sensor.name}
                                        disabled={disabled}
                                    />
                                    : null
                            }
                        </div>
                        {
                            isAdmin || (!isAdmin && disabled) ? (
                                <div>
                                    <div className="md-grid">
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Capacity (gal)"
                                            id="capacity"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('capacity', parseFloat(val))}
                                            value={sensor.capacity}
                                            disabled={disabled}
                                        />
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Height (in)"
                                            id="height"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('height', parseFloat(val))}
                                            value={sensor.height}
                                            disabled={disabled}
                                        />
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Length (in)"
                                            id="length"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('length', parseFloat(val))}
                                            value={sensor.length}
                                            disabled={disabled}
                                        />
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Width (in)"
                                            id="width"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('width', parseFloat(val))}
                                            value={sensor.width}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div className="md-grid">
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Hspace (in)"
                                            id="hspace"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('hspace', parseFloat(val))}
                                            value={sensor.hspace}
                                            disabled={disabled}
                                        />
                                        <TextField
                                            required
                                            type="number"
                                            step="any"
                                            label="Adjustment (in)"
                                            id="fineadjustment"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('fineadjustment', parseFloat(val))}
                                            value={sensor.fineadjustment}
                                            disabled={disabled}
                                        />
                                        <DatePicker
                                            required
                                            id="installationDate"
                                            label="Installation Date"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            calendarTitleClassName="md-text"
                                            onChange={val => this.updateObject('installationDate', val)}
                                            value={sensor.installationDate}
                                            disabled={disabled}
                                            locales="en-US"

                                            //necessario para não quebrar layout do calendario
                                            lastChild
                                            renderNode={null}
                                            disableScrollLocking
                                        //necessario para não quebrar layout do calendario

                                        />
                                        <Checkbox
                                            required
                                            type="checkbox"
                                            label="Status"
                                            id="status"
                                            name="status"
                                            className="md-cell md-cell--12 md-cell--3-desktop"
                                            onChange={val => this.updateObject('status', val)}
                                            defaultChecked={sensor.status}
                                            disabled={disabled}
                                        />
                                    </div>
                                </div>
                            ) : null
                        }
                        <CardActions className="md-divider-border md-divider-border--top">
                            <Button raised className="md-cell--left md-text--secondary"
                                onClick={() => { this.hide() }}>
                                Cancel
                            </Button>
                            {
                                !disabled ?
                                    <Button raised primary type="submit" className="md-cell--right"
                                        disabled={!isAdmin && invalidSensor}>
                                        Save
                                    </Button>
                                    : null
                            }
                        </CardActions>
                    </form>
                </DialogContainer>
            </div>
        );
    }
}

export default withSnackbar(TankCreateOrEdit);
